import React, { Component } from 'react';
import Icon from '@ant-design/icons';
import Style from './style';

const EyeSvg = () => (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" aria-hidden="true">
        <path d="M10 0.159058C5.45454 0.159058 1.57274 3.06172 0 7.15906C1.57272 11.2564 5.45454 14.1591 10 14.1591C14.55 14.1591 18.4273 11.2564 20 7.15906C18.4273 3.06172 14.55 0.159058 10 0.159058ZM10 11.8257C7.49092 11.8257 5.45454 9.73507 5.45454 7.15906C5.45454 4.58304 7.4909 2.49238 10 2.49238C12.5091 2.49238 14.5455 4.58304 14.5455 7.15906C14.5455 9.73507 12.5091 11.8257 10 11.8257ZM10 4.35906C8.49546 4.35906 7.27273 5.6144 7.27273 7.15906C7.27273 8.70372 8.49546 9.95906 10 9.95906C11.5045 9.95906 12.7273 8.70372 12.7273 7.15906C12.7273 5.6144 11.5045 4.35906 10 4.35906Z" fill="currentColor"/>
    </svg>

)

class EyeIcon extends Component {
    constructor (props) {
        super(props);
    }

    render () {
        return (
            <Icon className={`cicon ${this.props.className||''}`} style={Object.assign({},Style,this.props.style)} component={EyeSvg} aria-hidden="true" />
        )
    }
}
export default EyeIcon;
